export const getconfiguracion = async () => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_URL_APIHN24}/getconfiguracion/${process.env.REACT_APP_DB_EMPRESA}`,
      {
        method: "GET",
        headers: {
          'Authorization': 'Basic ' + btoa('hinetService:99RHinet202'), // Autenticación básica
          'Content-Type': 'application/json',
        },
      }
    );

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || "Error al cargar la configuración de usuario");
    }

    const data = await response.json();

    // Formatear la información necesaria
    // console.log(data);
    
    return data; // Devuelve el objeto configurado para su uso en la aplicación

  } catch (error) {
    // console.error("Error al cargar la configuración del usuario:", error.message);
    throw error; // Re-lanza el error para que pueda manejarse donde se llama esta función
  }
};

export const configuracion = async (configData) => {
  try {
    const response = await fetch(`${process.env.REACT_APP_URL_APIHN24}/configuracion`, {
      method: "POST",
      headers: {
        'Authorization': 'Basic ' + btoa('hinetService:99RHinet202'),
        "Content-Type": "application/json",
      },
      body: JSON.stringify(configData),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || "Error en la respuesta al guardar configuración");
    }

    const data = await response.json();
    return data; // { status: true, message: "..." }

  } catch (error) {
    // console.error("configuracion error:", error.message);
    throw error; // re-lanza para manejar donde se llame
  }
};

export const loadUserConfig2 = async () => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_URL_APIHN24}/configuracion/${process.env.REACT_APP_DB_EMPRESA}`,
      {
        method: "GET",
        headers: {
          'Authorization': 'Basic ' + btoa('hinetService:99RHinet202'), // Autenticación básica
          'Content-Type': 'application/json',
        },
      }
    );

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || "Error al cargar la configuración de usuario");
    }

    const data = await response.json();

    // Formatear la información necesaria
    // console.log('data',data);
    const config = {
        vista: {
          carousel_home:data.data?.vista?.carousel_home || 0,
          muestra_cuadrante:data.data?.vista?.muestra_cuadrante || 0,
          carousel_mueve:data.data?.vista?.carousel_mueve || 0,
          login: data.data?.vista?.login || 0, // Asegura que la propiedad 'login' exista y sea booleana
          vista: data.data?.vista?.vista || "tabla", // Valor por defecto 'tabla' si no está disponible
          registrarse:data.data?.vista?.registrarse || 0,
          monedaEcommerce: data.data?.vista?.monedaEcommerce || {}, // Objeto vacío como valor por defecto
          pago_enlinea: data.data?.vista?.pago_enlinea || 0 ,
          genera_presupuesto: data.data?.vista?.genera_presupuesto || 0 
        }
    };
     // Guardar 'vista.registrarse' en sessionStorage
   // sessionStorage.setItem('vista.registrarse', JSON.stringify(config.vista.registrarse));
    // console.log("Configuración cargada:", config);
    return config; // Devuelve el objeto configurado para su uso en la aplicación

  } catch (error) {
    // console.error("Error al cargar la configuración del usuario:", error.message);
    throw error; // Re-lanza el error para que pueda manejarse donde se llama esta función
  }
};


export const loadUserConfig = async () => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_URL_APIHN24}/inicializadatos/${process.env.REACT_APP_DB_EMPRESA}`,
      {
        method: "GET",
        headers: {
          'Authorization': 'Basic ' + btoa('hinetService:99RHinet202'), // Autenticación básica
          'Content-Type': 'application/json',
        },
      }
    );

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || "Error al cargar la configuración de usuario");
    }

    const data = await response.json();
    // console.log(data);
    // Formatear la información necesaria
  //  console.log('inicialziar',data);
    const config = {
      empresa: {
        id: data.data?.empresa?.id || null,
        nombre: data.data?.empresa?.nombre || "",
        fantasia: data.data?.empresa?.nombrefantasia || "",
        imagen: data.data?.empresa?.rimagen || "",
        cuit: data.data?.empresa?.cuit || "",
        direccion: data.data?.empresa?.direccion || "",
        provincia: data.data?.empresa?.pcia || "",
        pais: data.data?.empresa?.id_pais || "AR",
        emailAdmin: data.data?.empresa?.mailadmin || "",
        logo: data.data?.empresa?.rimagen || "",
        logo_login: data.data?.empresa?.logo_login || "",
        ivainc:data.data?.empresa?.incIva || 0,
      },
      config_ecommerce: {
        email: data.data?.config_ecommerce?.email || "",
        emails_contactos: data.data?.config_ecommerce?.emails_contactos || [],
        mobile: data.data?.config_ecommerce?.mobile || "",
        telefono: data.data?.config_ecommerce?.telefono || "",
        horario: data.data?.config_ecommerce?.horario || "",
        nosotros: data.data?.config_ecommerce?.nosotros || "",
      
        url_facebook: data.data?.config_ecommerce?.url_facebook || "",
        url_instagram: data.data?.config_ecommerce?.url_instagram || "",
        url_linkedin: data.data?.config_ecommerce?.url_linkedin || "",
        url_tiktok: data.data?.config_ecommerce?.url_tiktok || "",
        url_twitter: data.data?.config_ecommerce?.url_twitter || "",
        url_youtube: data.data?.config_ecommerce?.url_youtube || "",
      },
      mercadopago: {
        clienteid: data.data?.mercadopago?.clienteid || "",
        token_checkout: data.data?.mercadopago?.token_checkout || "",
        token_qr: data.data?.mercadopago?.token_qr || "",
        pos_id: data.data?.mercadopago?.pos_id || "",
        qr: data.data?.mercadopago?.qr || "",
      },
      
      grupos: Array.isArray(data.data?.grupos)
        ? data.data.grupos.map(grupo => ({
            codigo: grupo.Codigo || "Código no disponible",
            descripcion: grupo.Descrip || "Descripción no disponible",
            imagen: grupo.rutaimagen || "Imagen no disponible",
          }))
        : [],
      atributos: Array.isArray(data.data?.atributos1)
        ? data.data.atributos1.map(tipo => ({
            codigo: tipo.id || "Código no disponible",
            descripcion: tipo.valor?.trim() || "Descripción no disponible",
          }))
        : [],
        cuadrante: Array.isArray(data.data?.cuadrante)
        ? data.data.cuadrante.map(cuadra=> ({
          id: cuadra.id || "Código no disponible",
          rutaimagen: cuadra.rutaimagen ,
          url_destino:cuadra.url_destino,
          grupo_nombre:cuadra.grupo_nombre,
          }))
        : [],
      marcas: Array.isArray(data.data?.marcas)
        ? data.data.marcas.map(marca => ({
            clave_id: marca.Clave_id || "Clave no disponible",
            descripcion: marca.Descripcion || "Descripción no disponible",
            imagen: marca.rutaimagen || "Imagen no disponible",
          }))
        : [],
      tipos: Array.isArray(data.data?.tipos)
        ? data.data.tipos.map(tipo => ({
            codigo: tipo.Codigo || "Tipo no disponible",
            descripcion: tipo.Descrip || "Descripción no disponible",
          }))
        : [],        
        cond_impositiva: Array.isArray(data.data?.cond_impositiva)
        ? data.data.cond_impositiva.map(cond => ({
          Descripcion: cond.Descripcion,
          id_respiva: cond.id_respiva,
          }))
        : [],
        paises: Array.isArray(data.data?.paises)
        ? data.data.paises.map(pais => ({
          pais: pais.pais,
          id_pais: pais.id_pais,
          cod_pais: pais.cod_pais,
          cod_movil: pais.cod_movil,
          }))
        : [],
        provincias: Array.isArray(data.data?.provincias)
        ? data.data.provincias.map(provincia => ({
          nombre: provincia.DESCRIP,
          pais: provincia.cod_pais,
          pcia: provincia.pcia,
          }))
        : [],
      marcas_imagenes: Array.isArray(data.data?.marcas_imagenes)
        ? data.data.marcas_imagenes.map(marca => ({
            clave_id: marca.Clave_id || "Clave no disponible",
            descripcion: marca.Descripcion || "Descripción no disponible",
            imagen: marca.rutaimagen || "Imagen no disponible",
          }))
        : [],
        carousel: Array.isArray(data.data?.carousel)
        ? data.data.carousel.map(carouse => ({
            id: carouse.id || "0",
            activo: carouse.activo || "0",
            rutaimagen: carouse.rutaimagen|| "Imagen no disponible",
          }))
        : [],
      filtros: {
          condicion: data.data?.filtros?.condicion || 0,
          grupos: data.data?.filtros?.grupos || 0,
          marcas: data.data?.filtros?.marcas || 0,
          tipos: data.data?.filtros?.tipos || 0,
        },
      colores: Array.isArray(data.data?.colores)
        ? data.data.colores.map(color => color.codigo || "Color no disponible")
        : [],
      monedaEcommerce: {
        monedaCodigo:  data.data?.monedaEcommerce.monedaCodigo || "PESO",
        moneda:  data.data?.monedaEcommerce.monedaDescripcion || "PESOS",
        monedaSimbolo:  data.data?.monedaEcommerce.simboloCotizacion || "$",
        monedaCotizacion:  data.data?.monedaEcommerce.monedaCotizacion || "1",
        cotizacionSimbolo:  data.data?.monedaEcommerce.monedaSimbolo || "$",                    
      }                
    };

    //  console.log("Configuración cargada:", config);
    return config; // Devuelve el objeto configurado para su uso en la aplicación

  } catch (error) {
    // console.error("Error al cargar la configuración del usuario:", error.message);
    throw error; // Re-lanza el error para que pueda manejarse donde se llama esta función
  }
};

export const AgregarPresupuesto = async (orderData) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_URL_APIHN24}/AgregarPresupuesto`,
      {
        method: "POST",
        headers: {
          "Authorization": "Basic " + btoa("hinetService:99RHinet202"),
          "Content-Type": "application/json",
        },
        body: JSON.stringify(orderData),
      }
    );

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || "Error al enviar presupuesto");
    }

    return data;
  } catch (error) {
    // console.error("Error al agregar presupuesto:", error.message);
    throw error;
  }
};


export const login = async (email, password, uuid='', idempresa) => {
  try {
    const response = await fetch(`${process.env.REACT_APP_URL_APIHN24}/login`, {
      method: "POST",
      headers: {
        'Authorization': 'Basic ' + btoa('hinetService:99RHinet202'),
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        email,
        password,
        uuid,
        idempresa
      }),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || "Error en el inicio de sesión");
    }

    const data = await response.json();
    //console.log("Login exitoso:", data);
    //console.log('url',data.data.url_pedidos);
    // Suponiendo que la URL de los pedidos está en la respuesta
    const urlPedidos = data.data.url_pedidos || ''; // Ajusta según la respuesta real del backend

    // Guardamos la URL de los pedidos en el localStorage
    localStorage.setItem('url_pedidos', urlPedidos);

    // Guardamos la URL de los pedidos en el localStorage
    const urlPresupuestos= data.data.url_presupuestos || ''; // Ajusta según la respuesta real del backend
    // console.log(urlPresupuestos);
    localStorage.setItem('url_presupuestos', urlPresupuestos);
    // Guardamos los datos del cliente

    // Guardamos la URL de los pedidos en el localStorage
    const vista_ecommerce = data.data.cliente.vista_ecommerce || ''; // Ajusta según la respuesta real del backend
    // console.log(vista_ecommerce );
    localStorage.setItem('vista_ecommerce', vista_ecommerce );   

    return data;

  } catch (error) {
    console.error("Error en el inicio de sesión:", error.message);
    throw error;
  }
};

export const logout = async (email, password = '', uuid = "q") => {
  try {
    // Validar variable de entorno
    if (!process.env.REACT_APP_URL_APIHN24) {
      throw new Error("La variable de entorno REACT_APP_URL_APIHN24 no está configurada.");
    }

    // Validar datos requeridos
    if (!email) {
      throw new Error("El correo electrónico es obligatorio para cerrar sesión.");
    }

    // Preparar el cuerpo de la solicitud
    const body = {
      email,
      password,
      uuid,
    };

    // console.log("Datos enviados al servidor:", body);
    // Realizar la solicitud al servidor
    const response = await fetch(`${process.env.REACT_APP_URL_APIHN24}/logout`, {
      method: "POST",
      headers: {
        'Authorization': 'Basic ' + btoa('hinetService:99RHinet202'), // Autenticación básica
        'Content-Type': 'application/json', // Especificar que el contenido es JSON
      },
      body: JSON.stringify(body),
    });

    // Manejo de errores HTTP
    if (!response.ok) {
      let errorMessage = "Error en el cierre de sesión";
      try {
        const errorData = await response.json();
        errorMessage = errorData.message || errorMessage;
      } catch (parseError) {
       // console.error("Error al procesar la respuesta del servidor:", parseError);
      }
      throw new Error(errorMessage);
    }

    // Opcional: Manejo del resultado de éxito
    //  console.log("Cierre de sesión exitoso.");
  } catch (error) {
    // Manejar errores
    //console.error("Error en el cierre de sesión:", error.message);
    throw error; // Relanzar el error para que quien llame a esta función lo maneje
  }
};

export const addEvent = async (
  idusuario = 0,
  nrocli,
  ip,
  dispositivo,
  tipo_dispositivo,
  idevento,
  ocompra = '',
  sku = '',
  cantidad = 0,
  busca_item = '',
  item_comprado = 0,
  nro_int_ped = 0
) => {
  try {
    const id_session = localStorage.getItem("session");
    const empresa = process.env.REACT_APP_DB_EMPRESA;
    const apiUrl = process.env.REACT_APP_URL_APIHN24;

    if (!apiUrl) {
      console.warn("Fallo registrando evento: REACT_APP_URL_APIHN24 no esta configurada.");
      return null;
    }

    const response = await fetch(`${apiUrl}/evento`, {
      method: "POST",
      headers: {
        'Authorization': 'Basic ' + btoa('hinetService:99RHinet202'),
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        empresa,
        idusuario,
        nrocli,
        ip,
        dispositivo,
        tipo_dispositivo,
        idevento,
        ocompra,
        sku,
        cantidad,
        busca_item,
        item_comprado,
        id_session,
        nro_int_ped
      }),
    });

    if (!response.ok) {
      // Intentamos leer el cuerpo, pero si no es JSON no rompemos
      let errorMessage = "Error desconocido";
      try {
        const errorData = await response.json();
        errorMessage = errorData.message || errorMessage;
      } catch {
        // no pasa nada
      }
      console.warn("Fallo registrando evento:", errorMessage);
      return null;
    }

    // Intentamos parsear JSON de la respuesta
    try {
      const data = await response.json();
      return data;
    } catch {
      console.warn("Respuesta no válida del servidor");
      return { ok: true };
    }

  } catch (error) {
    console.warn("Error en registrar el evento:", error.message);
    return null; // no corta la ejecución del flujo principal
  }
};

